import type { ReactNode } from 'react'

export function CollectionCard({ artwork, title, subtitle, metadata, onClick }: { artwork: ReactNode; title: string; subtitle: string; metadata?: string; onClick: () => void }) {
  return <button type="button" onClick={onClick} className="group flex w-full min-w-0 flex-col gap-2 rounded-card p-2 text-left transition-colors hover:bg-surface-hover">
    {artwork}
    <span className="flex w-full min-w-0 flex-col">
      <span className="truncate text-sm font-medium text-text">{title}</span>
      <span className="truncate text-sm text-text-muted">{subtitle}</span>
      <span className="min-h-4 truncate text-xs text-text-subtle">{metadata}</span>
    </span>
  </button>
}
